import {Component, EventEmitter, Input, Output} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {faUpload} from "@fortawesome/free-solid-svg-icons";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import {OutlineButtonComponent} from "../../outline-button/outline-button.component";

@Component({
    selector: 'file-upload',
    styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css', 'file-upload.component.css'],
    imports: [FontAwesomeModule, FormsModule, MatCheckboxModule, OutlineButtonComponent],
    templateUrl: './file-upload.component.html'
})
export class FileUploadComponent {
  @Input('problem_template') problem_template!: FullProblemTemplate
  @Input('file_extensions') extensions: string[] = []
  @Input('answer') answer?: string = ''
  @Output() answerChange = new EventEmitter<{name: string, file: File}>()
  @Output() FileUploadChange = new EventEmitter<Function>()
  faUpload = faUpload

  ngOnInit() {
    this.answer = '';
  }

  fileUploadClick() {
    this.FileUploadChange.emit(this.FileUploadChange)
  }

  fileChange(event: Event) {
    const currentTarget = event.currentTarget as HTMLInputElement
    if (currentTarget.files && currentTarget.files.length > 0) {
      const file = currentTarget.files[0]
      this.answer = file.name
      this.answerChange.emit({name: this.answer, file: file})
      this.fileUploadClick()
    }    
  }
}